import DateDisplay from 'components/DateDisplay';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * Column for the nextRevisionDate.
 */
export default function NextRevisionDateColumn({ data: { nextRevisionDate } }: { data: RevisionRow }) {
  return nextRevisionDate ? <DateDisplay date={new Date(nextRevisionDate)} withRelative={false} /> : '';
}
